module.exports = __webpack_public_path__ + "img/neutre.d2415189.svg";